var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "d-flex align-center background-auth",
      staticStyle: { height: "100vh" },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "mx-auto text-left pa-8 bgPanel",
          attrs: { width: 480, flat: "", align: "center", justify: "center" },
        },
        [
          _c("v-col", { staticClass: "text-center pa-0 mt-2 mb-6" }, [
            _c("img", {
              attrs: {
                src: require(`@/assets/appBrand--ax-full.svg`),
                width: "211",
              },
            }),
            _c(
              "span",
              {
                staticClass:
                  "mt-n2 d-block subtitle-1 grey-500--text font-weight-bold",
              },
              [_vm._v("Iniciar sesión")]
            ),
          ]),
          _c("span", { staticClass: "text-body-2 text-grey-500" }, [
            _vm._v("Email"),
          ]),
          _c("v-text-field", {
            attrs: {
              error: _vm.$v.user.email.$error,
              outlined: "",
              "hide-details": "",
              required: "",
              "single-line": "",
              dense: "",
            },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.signIn.apply(null, arguments)
              },
            },
            model: {
              value: _vm.$v.user.email.$model,
              callback: function ($$v) {
                _vm.$set(_vm.$v.user.email, "$model", $$v)
              },
              expression: "$v.user.email.$model",
            },
          }),
          _c(
            "span",
            { staticClass: "d-block mt-5 text-body-2 text-grey-500" },
            [_vm._v("Contraseña")]
          ),
          _c("v-text-field", {
            staticClass: "pa-0",
            attrs: {
              error: _vm.$v.user.password.$error,
              outlined: "",
              "hide-details": "",
              required: "",
              "single-line": "",
              dense: "",
              type: "password",
            },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.signIn.apply(null, arguments)
              },
            },
            model: {
              value: _vm.$v.user.password.$model,
              callback: function ($$v) {
                _vm.$set(_vm.$v.user.password, "$model", $$v)
              },
              expression: "$v.user.password.$model",
            },
          }),
          _vm.invalidCredentials
            ? _c(
                "v-col",
                { staticClass: "pa-0 mt-3 text-center" },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "body-2 red--text pa-0",
                      attrs: {
                        border: "left",
                        "colored-border": "",
                        color: "white",
                        dense: "",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("auth.invalidCredentials")))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-btn",
            {
              staticClass: "mt-13 mb-2",
              attrs: {
                loading: _vm.signInLoader,
                color: "grey-900",
                block: "",
              },
              on: {
                click: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.signIn.apply(null, arguments)
                },
              },
            },
            [_vm._v("Iniciar sesión")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }